import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = new URLSearchParams(location.search).get('token');

    if (token) {
      localStorage.setItem('token', token);
      // You can also store other user data if it's passed in the URL
      navigate('/dashboard');
    } else {
      // Handle the case where the token is not present
      navigate('/auth/login/candidate?error=authentication-failed');
    }
  }, [location, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p>Finalizing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
